import { render } from "./AppManageInviteFriends.vue?vue&type=template&id=cdffd1ae&scoped=true"
import script from "./AppManageInviteFriends.vue?vue&type=script&lang=js"
export * from "./AppManageInviteFriends.vue?vue&type=script&lang=js"

import "./AppManageInviteFriends.vue?vue&type=style&index=0&id=cdffd1ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdffd1ae"],['__file',"src/views/AppManage/AppManageInviteFriends.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cdffd1ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdffd1ae', __exports__)) {
    api.reload('cdffd1ae', __exports__)
  }
  
  module.hot.accept("./AppManageInviteFriends.vue?vue&type=template&id=cdffd1ae&scoped=true", () => {
    api.rerender('cdffd1ae', render)
  })

}


export default __exports__